import { mainAxios,
  REQUEST_PHONE_VERIFICATION,
  CHECK_PHONE_VERIFICATION,
  CREATE_ACCOUNT,
  RESET_PASSWORD } from '@/backend/vue-axios'
import { router } from '@/router'
import store from '@/store'
import {
  SET_REQUEST_VERIFICATION_LOADING,
  SET_CHECK_VERIFICATION_LOADING,
  SET_USER_REGISTRATION_LOADING,
  SET_USER,
  SET_PHONE_VERIFIED,
  SET_REQUEST_PHONE_NUMBER,
  REQUEST_PHONE_NUMBER_SUCCESS,
  REQUEST_PHONE_NUMBER_FAILURE,
  CHECK_PHONE_NUMBER_SUCCESS,
  CHECK_PHONE_NUMBER_FAILURE,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  SET_RESET_PASSWORD_LOADING,
  SEND_RESET_PASSWORD_EMAIL_SUCCESS,
  SEND_RESET_PASSWORD_EMAIL_FAILURE
} from './account-mutation-types'

const state = {
  requestPhoneVerificationLoading: false,
  checkPhoneVerificationLoading: false,
  userRegistrationLoading: false,
  resetPasswordLoading: false,
  registrationStepNames: ['phone-verification-request', 'phone-verification-check', 'user-registration'],
  currentRegistrationStep: 0,
  requestPhoneNumber: null,
  user: null
}

const getters = {
  getRequestPhoneVerificationLoading: (state) => {
    return state.requestPhoneVerificationLoading
  },
  getCheckPhoneVerificationLoading: (state) => {
    return state.checkPhoneVerificationLoading
  },
  getUserRegistrationLoading: (state) => {
    return state.userRegistrationLoading
  },
  getResetPasswordLoading: (state) => {
    return state.resetPasswordLoading
  },
  getRequestPhoneNumber: (state) => {
    return state.requestPhoneNumber
  },
  getCurrentRegistrationStep: (state) => {
    return state.currentRegistrationStep
  },
  getRegistrationStepByName: (state) => (name) => {
    return state.registrationStepNames.indexOf(name)
  },
  getRegistrationStepByIndex: (state) => (index) => {
    if (index >= 0 && index < state.registrationStepNames.length) {
      return state.registrationStepNames[index]
    } else {
      return state.registrationStepNames[0]
    }
  },
  getUser: (state) => {
    return state.user
  }
}

const actions = {
  setUser ({ commit }, { val }) {
    commit(SET_USER, { val })
  },
  setRequestPhoneNumber: ({ commit }, { val }) => {
    commit(SET_REQUEST_PHONE_NUMBER, { val })
  },
  requestPhoneVerification ({ commit }, { phoneNumber }) {
    commit(SET_REQUEST_VERIFICATION_LOADING, { val: true })
    mainAxios.defaults.headers.common['Authorization'] = ''
    mainAxios.post(REQUEST_PHONE_VERIFICATION, { phone_number: phoneNumber })
      .then(request => {
        commit(REQUEST_PHONE_NUMBER_SUCCESS, { data: request.data })
      }).catch(error => {
        commit(REQUEST_PHONE_NUMBER_FAILURE, { data: error.response.data })
      })
  },
  checkPhoneVerification ({ commit }, { phoneNumber, code }) {
    commit(SET_CHECK_VERIFICATION_LOADING, { val: true })
    mainAxios.defaults.headers.common['Authorization'] = ''
    mainAxios.post(CHECK_PHONE_VERIFICATION, { phone_number: phoneNumber, code })
      .then(request => {
        commit(CHECK_PHONE_NUMBER_SUCCESS, { data: request.data })
      }).catch(error => {
        commit(CHECK_PHONE_NUMBER_FAILURE, { data: error.response.data })
      })
  },
  register ({ commit }, { firstName, lastName, email, username, password, phoneNumber }) {
    commit(SET_USER_REGISTRATION_LOADING, { val: true })
    mainAxios.defaults.headers.common['Authorization'] = ''
    mainAxios.post(CREATE_ACCOUNT, {
      first_name: firstName,
      last_name: lastName,
      username,
      email,
      password,
      platform: 'web',
      is_verify_email: false,
      phone_number: phoneNumber })
      .then(request => {
        commit(REGISTER_SUCCESS, { data: request.data })
      }).catch(error => {
        commit(REGISTER_FAILURE, { data: error.response.data })
      })
  },
  resetPassword ({ commit }, { email }) {
    commit(SET_RESET_PASSWORD_LOADING, { val: true })
    mainAxios.defaults.headers.common['Authorization'] = ''
    mainAxios.post(RESET_PASSWORD, {
      email: email
    }).then(request => {
      commit(SEND_RESET_PASSWORD_EMAIL_SUCCESS, { data: request.data })
    }).catch(error => {
      commit(SEND_RESET_PASSWORD_EMAIL_FAILURE, { data: error.response.data })
    })
  }
}

const mutations = {
  [SET_REQUEST_VERIFICATION_LOADING] (state, { val }) {
    state.requestPhoneVerificationLoading = val
  },
  [SET_CHECK_VERIFICATION_LOADING] (state, { val }) {
    state.checkPhoneVerificationLoading = val
  },
  [SET_USER_REGISTRATION_LOADING] (state, { val }) {
    state.userRegistrationLoading = val
  },
  [SET_RESET_PASSWORD_LOADING] (state, { val }) {
    state.resetPasswordLoading = val
  },
  [SET_USER] (state, { val }) {
    state.user = val
  },
  [SET_PHONE_VERIFIED] (state, { val }) {
    state.isPhoneVerified = val
  },
  [SET_REQUEST_PHONE_NUMBER] (state, { val }) {
    state.requestPhoneNumber = val
  },
  [REQUEST_PHONE_NUMBER_SUCCESS] (state, { data }) {
    const nextStepName = 'phone-verification-check'
    state.requestPhoneVerificationLoading = false
    state.currentRegistrationStep = state.registrationStepNames.indexOf(nextStepName)
    router.push({ name: nextStepName })
  },
  [REQUEST_PHONE_NUMBER_FAILURE] (state, { data }) {
    const currentStepName = 'phone-verification-request'
    state.requestPhoneVerificationLoading = false
    state.currentRegistrationStep = state.registrationStepNames.indexOf(currentStepName)
    store.dispatch('alert/error', data.content.errors.message)
  },
  [CHECK_PHONE_NUMBER_SUCCESS] (state, { data }) {
    const nextStepName = 'user-registration'
    state.checkPhoneVerificationLoading = false
    state.currentRegistrationStep = state.registrationStepNames.indexOf(nextStepName)
    router.push({ name: 'user-registration' })
  },
  [CHECK_PHONE_NUMBER_FAILURE] (state, { data }) {
    const currentStepName = 'phone-verification-check'
    state.checkPhoneVerificationLoading = false
    state.currentRegistrationStep = state.registrationStepNames.indexOf(currentStepName)
    store.dispatch('alert/error', data.content.errors.message)
  },
  [REGISTER_SUCCESS] (state, { data }) {
    state.userRegistrationLoading = false
    state.user = data.user
    state.currentRegistrationStep = 0
    router.push({ name: 'login', query: { alert_message: 'Create an user successfully', type: 'success' } })
    store.dispatch('alert/success', 'Create an user successfully.')
  },
  [REGISTER_FAILURE] (state, { data }) {
    const currentStepName = 'user-registration'
    state.userRegistrationLoading = false
    state.currentRegistrationStep = state.registrationStepNames.indexOf(currentStepName)
    store.dispatch('alert/error', data.error_message)
  },
  [SEND_RESET_PASSWORD_EMAIL_SUCCESS] (state, { data }) {
    state.resetPasswordLoading = false
    store.dispatch('alert/success', 'Send Change Password Email successfully')
  },
  [SEND_RESET_PASSWORD_EMAIL_FAILURE] (state, { data }) {
    state.resetPasswordLoading = false
    store.dispatch('alert/error', data.error_message)
  }
}

export const account = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
